
<template>
  <div class="box">
    <ul class="con1" ref="con1" :class="{anim:animate==true}">
      <div v-if="this.messageList.length">
        <li v-for='(item,index) in messageList' :key="index">
          <span class="my-uname">{{item.nickName | nameencry}}捐助了{{item.ordAmount | sumFormat}}本 </span>
          <span style="display: inline-block;margin-left: 10px">{{item.successTime | relativeTime}}</span>
        </li>
      </div>
      <div v-else>
        <li>
          <span class="my-uname" v-if="id == 3">捐款活动已开启</span>
          <span class="my-uname" v-else>捐款活动已结束</span>
        </li>
      </div>


    </ul>
  </div>
</template>

<script>
export default {
  name: 'my-marquee-left',
  props: {
    sendVal: Array,
    id: String
  },
  data () {
    return {
      animate:false, //控制过渡动画是否开启
      List:[],//通知消息列表
      nowTime:null,
      messageList:[]
    }
  },
  mounted () {
    this.List = JSON.parse(JSON.stringify(this.sendVal));
     setInterval(this.messagescroll,3000)
  },
  beforeDestroy () {
    // 页面关闭清除定时器
    clearInterval(this.nowTime)
    // 清除定时器标识
    this.nowTime = null
  },
  methods: {
    messagescroll(){
      this.animate=true;    // 开启过渡动画
      this.nowTime = setTimeout(()=>{
        if(this.List.length){
          this.messageList.push(this.List[0])
          this.List.splice(0,1)
          if(this.messageList.length>1){
            this.messageList.shift();
          }
        }else {
          this.List = JSON.parse(JSON.stringify(this.sendVal));
        }
        // this.messageList.push(this.sendVal[0]);  // 将数组的第一个元素追加到数组最后面
        // this.messageList.shift();               //然后删除数组的第一个元素
        // console.log(this.messageList)
        this.animate=false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      },3500)
    },
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 420px;
  height: 80px;
  background: linear-gradient(25.61deg, rgba(171, 115, 169, 0.7) -1.58%, rgba(193, 153, 198, 0.7) 92.43%);
  /* Donation H5 Color/主色3 */

  border: 1px solid #F3EBF4;
  border-radius: 71px;
  color: #FFFFFF;
  text-align: center;
  overflow: hidden;
  margin-left: 1.5%;
  margin-top:80px;
  border-radius: 50px;
}
.anim{
  transition: all 0.5s;
  margin-top: -80px;
}
.con1 li{
  list-style: none;
  line-height: 80px;
  height: 80px;
  font-size: 24px;
  span{
    display: inline-block;
    color: #FFFFFF;
  }
}

</style>


